import { render, staticRenderFns } from "./prompt-dialog.vue?vue&type=template&id=57a468f3&scoped=true&"
import script from "./prompt-dialog.vue?vue&type=script&lang=js&"
export * from "./prompt-dialog.vue?vue&type=script&lang=js&"
import style0 from "./prompt-dialog.vue?vue&type=style&index=0&id=57a468f3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a468f3",
  null
  
)

export default component.exports